document.addEventListener('DOMContentLoaded', function () {

  /* ELIMINA LA NOTIFICACIÓN ANTIGUA DE LA LANDING */
  const barraAntigua = document.getElementById('rbPurchaseBar');

  if (barraAntigua) {
    barraAntigua.remove();
  }

  /* EVITA DUPLICADOS */
  const barraExistente = document.getElementById('rb-purchase-bar');

  if (barraExistente) {
    barraExistente.remove();
  }

  const compradores = [
    'Carolina M. de Santiago, Chile',
    'Rodrigo P. de Valparaíso, Chile',
    'Valentina G. de Concepción, Chile',
    'Mateo S. de Antofagasta, Chile',
    'Isabel F. de La Serena, Chile',
    'Sebastián R. de Temuco, Chile',
    'Daniela T. de Viña del Mar, Chile',
    'Andrés L. de Puerto Montt, Chile',
    'Camila O. de Rancagua, Chile',
    'Joaquín V. de Talca, Chile',
    'Fernanda B. de Iquique, Chile',
    'Nicolás A. de Chillán, Chile',
    'Antonia H. de Valdivia, Chile',
    'Gabriel N. de Copiapó, Chile',
    'Sofía D. de Punta Arenas, Chile'
  ];

  const barra = document.createElement('div');

  barra.id = 'rb-purchase-bar';

  barra.innerHTML = `
    <div class="rb-purchase-inner">

      <div class="rb-purchase-icon">
        🌿
      </div>

      <div class="rb-purchase-copy">

        <div class="rb-purchase-name"></div>

        <div class="rb-purchase-bottom">

          <span class="rb-purchase-text">
            compró Reinicio Bariátrico 21 Días
          </span>

          <span class="rb-purchase-verified">
            ✓ COMPRA VERIFICADA
          </span>

        </div>

      </div>

    </div>
  `;

  document.body.appendChild(barra);

  const style = document.createElement('style');

  style.textContent = `

    #rb-purchase-bar {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      z-index: 9999999;

      background: #FBF8F1;

      border-top:
        1px solid rgba(48,69,47,.16);

      border-radius:
        18px 18px 0 0;

      box-shadow:
        0 -10px 32px
        rgba(48,69,47,.18);

      transform:
        translateY(125%);

      opacity: 0;

      visibility: hidden;

      transition:
        transform .55s cubic-bezier(.22,.8,.3,1),
        opacity .4s ease,
        visibility .4s ease;
    }

    #rb-purchase-bar.rb-show {

      transform:
        translateY(0);

      opacity: 1;

      visibility: visible;
    }

    .rb-purchase-inner {

      width: 100%;

      max-width: 1180px;

      min-height: 82px;

      margin: 0 auto;

      padding:
        11px 24px
        max(10px, env(safe-area-inset-bottom));

      display: flex;

      align-items: center;

      gap: 15px;

      box-sizing: border-box;
    }

    .rb-purchase-icon {

      width: 46px;

      height: 46px;

      flex: 0 0 46px;

      border-radius: 50%;

      display: flex;

      align-items: center;

      justify-content: center;

      background: #E7EEDF;

      border:
        1px solid rgba(48,69,47,.12);

      font-size: 21px;
    }

    .rb-purchase-copy {

      flex: 1;

      min-width: 0;
    }

    .rb-purchase-name {

      color: #30452F;

      font-size: 15px;

      line-height: 1.25;

      font-weight: 900;

      white-space: normal;

      overflow: visible;

      margin-bottom: 4px;
    }

    .rb-purchase-bottom {

      display: flex;

      align-items: center;

      flex-wrap: wrap;

      gap: 5px 12px;
    }

    .rb-purchase-text {

      color: #657062;

      font-size: 13px;

      line-height: 1.3;
    }

    .rb-purchase-verified {

      display: inline-flex;

      align-items: center;

      color: #30452F;

      background: #E7EEDF;

      border:
        1px solid rgba(48,69,47,.12);

      border-radius: 999px;

      padding: 4px 9px;

      font-size: 10px;

      font-weight: 900;

      letter-spacing: .25px;

      white-space: nowrap;
    }

    @media (max-width: 600px) {

      #rb-purchase-bar {

        border-radius:
          15px 15px 0 0;
      }

      .rb-purchase-inner {

        min-height: 80px;

        padding:
          8px 12px
          max(
            8px,
            env(safe-area-inset-bottom)
          );

        gap: 9px;
      }

      .rb-purchase-icon {

        width: 39px;

        height: 39px;

        flex-basis: 39px;

        font-size: 18px;
      }

      .rb-purchase-name {

        font-size: 12.5px;

        margin-bottom: 2px;
      }

      .rb-purchase-text {

        font-size: 11px;
      }

      .rb-purchase-verified {

        font-size: 9px;

        padding: 3px 7px;
      }
    }
  `;

  document.head.appendChild(style);

  const nombre =
    barra.querySelector(
      '.rb-purchase-name'
    );

  let ultimoIndice = -1;

  function elegirComprador() {

    let indice;

    do {

      indice =
        Math.floor(
          Math.random() *
          compradores.length
        );

    } while (
      indice === ultimoIndice &&
      compradores.length > 1
    );

    ultimoIndice = indice;

    return compradores[indice];
  }

  function mostrarCompra() {

    nombre.textContent =
      elegirComprador();

    barra.classList.add(
      'rb-show'
    );

    setTimeout(
      function () {

        barra.classList.remove(
          'rb-show'
        );

      },
      5000
    );
  }

  /* PRIMERA COMPRA A LOS 3 SEGUNDOS */
  setTimeout(
    mostrarCompra,
    3000
  );

  /* DESPUÉS, CADA 14 SEGUNDOS */
  setInterval(
    mostrarCompra,
    14000
  );

});